<script setup lang="ts">
import { computed } from 'vue'
import { hostMeterTone } from './HostMeterTone'

// One labelled resource meter on the Host card (CPU / Memory / Disk):
// name on the left, the mono value on the right, a thin fill bar below.
// `percent` null (metric unavailable) renders an empty track and drops
// the meter's numeric value rather than implying 0%.
const props = defineProps<{
  label: string
  value: string
  percent: number | null
  valueTestid: string
}>()

const rounded = computed(() => (props.percent == null ? null : Math.round(props.percent)))
const fillStyle = computed(() => ({ width: `${props.percent ?? 0}%` }))
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <div class="flex items-baseline justify-between gap-3">
      <span class="text-ink-muted">{{ label }}</span>
      <span class="font-mono text-xs text-ink tabular-nums" :data-testid="valueTestid">{{ value }}</span>
    </div>
    <span
      role="meter"
      :aria-label="label"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="rounded ?? undefined"
      :aria-valuetext="rounded == null ? 'unavailable' : `${rounded}% — ${value}`"
      class="block h-2 overflow-hidden rounded bg-border-divider"
    >
      <span class="block h-full rounded-[inherit]" :class="hostMeterTone(percent)" :style="fillStyle" />
    </span>
  </div>
</template>
